import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';

import { GeocodeService } from '@main-client/src/app/core/geocode.service';
import { LocationService } from '@main-client/src/app/core/location.service';

import { LocationAutocompleteComponent } from './location-autocomplete.component';

import { TtcMatInputModule } from '../ttc-mat-input/ttc-mat-input.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    TtcMatInputModule,
  ],
  declarations: [LocationAutocompleteComponent],
  exports: [LocationAutocompleteComponent],
  providers: [GeocodeService, LocationService],
})
export class LocationAutocompleteModule {}
